(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/frs-donation/components/credit/partials/designation', '<div class="donation-credit_designation" ng-class="{\'no-fundraising\': !campaign.HAS_FUNDRAISING}">\n' + '  <program-designation-field\n' + '    entity="campaign.current"\n' + '    selected-id="campaign.current.designation_id"\n' + '    model="MODEL.designation_id"\n' + '    form-name="FORM"\n' + '    field-option-settings="designationOptions"\n' + '  >\n' + '  </program-designation-field>\n' + '</div>\n' + '');
}]);
})();